import axios from 'axios';
import { postData, errorHandler } from './index'
import { AUTH_USER, AUTH_USER_EXIST, AUTH_ERROR, FORGOT_PASSWORD_ACCOUNT,
   RESET_PASSWORD_ACCOUNT, AUTH_RESET_MESSAGE, SET_INITIAL_STATE_PROJECT, SET_INITIAL_STATE_CONSULTANT } from './types'
import { API_URL } from './index';

export function loginUser({ email, password }) {
  return function (dispatch) {
    axios.post(`${API_URL}/auth/login`, { email, password })
    .then((response) => {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('endpoint', response.data.user.group);
        localStorage.setItem('features', JSON.stringify(response.data.user.features));
        if (response.data.user.group === "aegis") {
            localStorage.setItem("ikos-language", 'en')
        }
      
      dispatch({
        payload : response.data,
        type: AUTH_USER
      });

    })
    .catch((error) => {
      errorHandler(dispatch, error.response, AUTH_ERROR);
    });
  };
}

export function registerUser(user) {
  return function (dispatch) {
    axios.post(`${API_URL}/auth/register`, user)
    .then((response) => {
      if(response.data.message === "Email already used"){
        dispatch({
          type: AUTH_USER_EXIST,
          payload : response.data
        });
      }else{
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        dispatch({
          type: AUTH_USER,
          payload : response.data
        });
      }

    })
    .catch((error) => {
      errorHandler(dispatch, error.response, AUTH_ERROR);
    });
  };
}

export function logoutUser(error, type) {
  return function (dispatch) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    dispatch({
      type: SET_INITIAL_STATE_PROJECT
    });
    dispatch({
      type: SET_INITIAL_STATE_CONSULTANT
    });
    dispatch({ type, payload: error || '' });
    // window.location.href = `${CLIENT_ROOT_URL}/`;
  };
}

export function resetMessage(){
  return function(dispatch){
    dispatch({
      type: AUTH_RESET_MESSAGE
    });
  }
}

export function forgotPassword(email){
  const url = '/auth/forgot-password';
  return dispatch => postData(FORGOT_PASSWORD_ACCOUNT, AUTH_ERROR, false, url, dispatch, {email : email});
}

export function resetPassword(password,token){
  const url = '/auth/reset-password/'+token;
  return dispatch => postData(RESET_PASSWORD_ACCOUNT, AUTH_ERROR, false, url, dispatch, { password });
}
